import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=577cd7a2&scoped=true&"
import script from "./QuestionInfo.vue?vue&type=script&lang=ts&"
export * from "./QuestionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=577cd7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577cd7a2",
  null
  
)

export default component.exports